import React, { useCallback, useEffect } from 'react';
import { View, StyleSheet } from "react-native";
//import { Calendar } from 'react-native-calendars';
import dayjs from 'dayjs';
import { useRouter } from 'expo-router';
import { usePersistBoundStore, usePersistSecureBoundStore } from '@/services/zustand/Store';

const INITIAL_DATE = dayjs().format('YYYY-MM-DD');

interface MarkedDate {
    selected: boolean;
    marked: boolean;
    dotColor: string;
}

interface MarkedDates {
    [date: string]: MarkedDate;
}

export default function DatePicker() {
    const router = useRouter();
    const user = usePersistSecureBoundStore(useCallback((state) => state.user, []));
    const getAllStoredEpapers = usePersistBoundStore(useCallback((state) => state.getAllStoredEpapers, []));

    const markedDates: MarkedDates = {};
    const epapers = getAllStoredEpapers();

    const handleLinkPress = async (day: any) => {
        const formattedDate = day.dateString.replace(/-/g, '');
        if (user) {
            router.push('/(tabs)/PDFSelector');
        } else {
            router.push('/(auth)/PDFSelector');
        }
    };

    useEffect(() => {
         epapers.forEach(epaper => {
             const date = dayjs(epaper.magazine.date, 'YYYYMMDD').format('YYYY-MM-DD');
             markedDates[date] = { selected: false, marked: true, dotColor: 'green' };
        });
    }, []);

    return (
        <View>
            {/* <Calendar
                enableSwipeMonths
                current={INITIAL_DATE}
                style={styles.calendar}
                onDayPress={handleLinkPress}
                markedDates={markedDates}
            /> */}
        </View>
    );
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: '#F5FCFF',
    },
    dayContainer: {
        justifyContent: 'center',
        alignItems: 'center',
    },
    customText: {
        fontSize: 12,
        color: 'gray',
    },
    text: {
        textAlign: 'center',
        padding: 10,
        backgroundColor: 'lightgrey',
        fontSize: 16
    },
    calendar: {
        marginBottom: 10
    },
});
